import { Link } from "react-router";

const Category = (props: any) => {
    return (
        <>
            <Link to={`/categories/${props.slug}`} className="text-decoration-none text-black">
                <div data-aos="fade-down" data-aos-duration="1500" style={{ backgroundImage: `url(${props.icon})` }} className="card border-0 pt-0 category-card " >
                    <div className="w-100 d-flex justify-content-center align-items-end h-100 bg-gradiant ">
                        <div className="py-3 w-100">
                            <p className="text-center text-white mb-0 fw-bold font-medium-lg">
                                {props.name}
                            </p>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

export default Category;